import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import AddressInfoDisplay, { AddressInfoDisplayStyles } from "@insite/content-library/Components/AddressInfoDisplay";
import { OrderDetailsPageContext } from "@insite/content-library/Pages/OrderDetailsPage";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import {OrderStatusPageContext} from "@MasterBluePrint/Overrides/Pages/OrderStatusPage";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import themeColors, { themeFontSizes, themeFontWeights, themeIndentSizes } from "@MasterBluePrint/Styles/variables";
import React, { FC, useContext } from "react";
import { css } from "styled-components";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { connect } from "react-redux";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";

export interface OrderDetailsBillingAddressStyles {
    titleText?: TypographyProps;
    addressDisplay?: AddressInfoDisplayStyles;
    wrapper?: InjectableCss;
}
const mapStateToProps = (state: ApplicationState) => ({
    orderData: state.pages.orderStatus.order,
});
type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export const billingAddressStyles: OrderDetailsBillingAddressStyles = {
    wrapper: {
        css: css`
            padding-bottom: .625rem;

            address {
                color: ${themeColors.colorCharcoalGrey};
                font-family: 'Lato',sans-serif;
                font-size: ${themeFontSizes.size14};
                letter-spacing: 0.44px;
                line-height: 1.5rem;
                margin-top: 15px;

                p {
                    color: ${themeColors.colorCharcoalGrey};
                    font-family: 'Lato',sans-serif;
                    font-size: ${themeFontSizes.size14};
                    letter-spacing: 0.44px;
                }
            }
        `,
    },
    titleText: {
        variant: "h6",
        as: "h2",
        css: css`
            @media print {
                font-size: .75rem;
            }
            margin-bottom: .31250625rem;
            color: #002554;
            font-family: Roboto;
            font-size: 16px;
            font-weight: bold;
            letter-spacing: 0;
            line-height: 23px;
        `,
    },
};

const styles = billingAddressStyles;

const OrderDetailsBillingAddress:  FC<Props> = ({ orderData }) => {
    const { value: order } = useContext(OrderStateContext);

    if (!order && !orderData) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText}>{translate('Billing Information')}</Typography>
            <AddressInfoDisplay
                firstName={order?.properties.btFirstName??orderData?.properties.btFirstName}
                lastName={order?.properties.btLastName??orderData?.properties.btLastName}
                companyName={order?.btCompanyName??orderData?.btCompanyName}
                address1={order?.btAddress1??orderData?.btAddress1??""}
                address2={order?.btAddress2??orderData?.btAddress2}
                address3={order?.btAddress3??orderData?.btAddress3}
                address4={order?.btAddress4??orderData?.btAddress4}
                city={order?.billToCity??orderData?.billToCity??""}
                state={order?.billToState??orderData?.billToState}
                postalCode={order?.billToPostalCode??orderData?.billToPostalCode??""}
                country={order?.btCountry??orderData?.btCountry}
                extendedStyles={styles.addressDisplay}
            />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(OrderDetailsBillingAddress),
    definition: {
        allowedContexts: [OrderDetailsPageContext,OrderStatusPageContext,"RfqQuoteDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;